export default {
  container: {
    backgroundColor: '#333D47',
    color: 'tmWhite',
    mt: ['80px', '47px', '72px'],

    ul: {
      margin: '0 0 25px 0',
      padding: '0',
      listStylePosition: 'inside',

      li: {
        fontSize: ['', '12px'],
        lineHeight: '22px',
        marginBottom: ['10px', '', ''],
      },
    },
  },
  contentWrapper: {
    margin: ['0 auto -80px auto', '0 auto -80px auto', '0 auto -140px auto'],
    p: ['39px 35px 40px 35px', '39px 35px 40px 35px', '51px 0 11px 10px'],
    maxWidth: ['100%', '910px'],
    borderBottom: '1px solid rgba(249, 249, 249, 0.25)',
  },

  title: {
    backgroundColor: '#262729',
    borderRadius: '20px',
    width: 'fit-content',
    padding: '5px 10px',
    fontFamily: 'heading',
    fontSize: '16px',
    marginBottom: '35px',
  },
  thirdSectionTitle: {
    fontSize: '18px',
    marginBottom: '10px',
  },
  thirdSectionText: {
    fontSize: '12px',
  },
}
